//表格设置panel
import {GoingUtils} from "goingutils";

class GridSettingPanel {

    constructor(queryFieldAry, targetObj) {
        this.panelId = GoingUtils.getUUid(12);
        this.targetObj = targetObj;
        this.initPanelBody(this.panelId, queryFieldAry);
        this.initPanelEvent();
    }

    initPanelEvent() {
        let settingObj = this;
        $(`#${this.panelId} .check-items .row`).click(function () {
            let idd = $(this)
                .find(".sel-item")
                .attr("idd");
            let curChSrc = $(this)
                .find(".check-bpx .ivu-icon")
                .prop("class");
            if (curChSrc.indexOf("ivu-icon-md-square-outline") > 0) {
                //显示列
                settingObj["targetObj"].setColumnHidden(
                    settingObj["targetObj"].getColIndexByField(idd),
                    false
                );
                $(this)
                    .find(".check-bpx .ivu-icon")
                    .prop("class",  `ivu-icon ivu-icon ivu-icon-md-checkbox color-blue`);
            } else {
                //隐藏列
                settingObj["targetObj"].setColumnHidden(
                    settingObj["targetObj"].getColIndexByField(idd),
                    true
                );
                $(this)
                    .find(".check-bpx .ivu-icon")
                    .prop("class",  `ivu-icon ivu-icon ivu-icon-md-square-outline color-gray`);
            }
        });
        //点击切换
        $(`#${this.panelId} .ivu-switch`).click(function () {
            let idd = $(this).attr("idd");
            let text = $(this).attr("text");
            if ($(this).hasClass("ivu-switch-checked")) {
                $(this).removeClass("ivu-switch-checked");
                $(this)
                    .find(".ivu-switch-inner span")
                    .prop("slot`", "close")
                    .text("关闭");
                settingObj["targetObj"].closeFooterBar(idd, text);
            } else {
                $(this).addClass("ivu-switch-checked");
                $(this)
                    .find(".ivu-switch-inner span")
                    .prop("slot", "open")
                    .text("开启");
                settingObj["targetObj"].addFooterBar(idd, text);
            }
        });
        $(document.body).click(function (e) {
            let target = $(e.target);
            if (
                !target.is(".go-setting-grid" + " *") &&
                !target.is(".setting-btn" + " *")
            ) {
                $(".go-setting-grid").hide();
            }
        });
        //如果点击grid的box
        $(".objbox").click(function () {
            $(".go-setting-grid").hide();
        });
    }

    //获取每项对应的html代码
    getItemHtml({id, label,hidden}) {
        if(label==null||label===""||label==='undefined'){
            return "";
        }
        return `<div class="row clearfix">
         <div class="cell pull-left check-box-cell">
            <div class="check-bpx"  title="" >
                ${hidden===true?'<i class="ivu-icon ivu-icon ivu-icon-md-square-outline color-gray" style="font-size: 20px;position: relative;top:-4px;" title=""></i>'
                    :'<i class="ivu-icon ivu-icon ivu-icon-md-checkbox color-blue" style="font-size: 20px;position: relative;top:-4px;" title=""></i>'} 
            </div>
         </div>
         <div class="celll pull-left sel-item" idd="${id}" style="margin-left: 5px;margin-top:2px;">${label}</div>
        </div>`;
    }

    //初始化panel的body信息
    initPanelBody(panelId, queryFieldAry) {
        let bodyHtmls = [];
        let settingCtl = this;
        queryFieldAry.forEach(function (item) {
            bodyHtmls.push(settingCtl.getItemHtml(item));
        });

        $(`<div class="go-setting-grid" id="${panelId}">
        <div class="check-items">
        ${bodyHtmls.join("")}
        </div>
        <div class="operation-items">
             <div class="row clearfix">
                <div class="pull-left operation-label">选计：</div>
                <div class="pill-left">
                     <span class="ivu-switch ivu-switch-large" idd="selCount" text="选计">
                    <span class="ivu-switch-inner">
                        <!--v-if-->
                        <span slot="close">关闭</span><!--v-if-->
                    </span>
                </span>
                </div>
            </div>
             <div class="row clearfix">
                <div class="pull-left operation-label">小计：</div>
                <div class="pill-left">
                     <span class="ivu-switch ivu-switch-large"  idd="sumCount"  text="小计">
                    <span class="ivu-switch-inner">
                        <!--v-if-->
                        <span slot="close">关闭</span><!--v-if-->
                    </span>
                </span>
                </div>
            </div>
            
          
             <div class="row clearfix">
                <div class="pull-left operation-label">总计：</div>
                <div class="pill-left">
                       <span class="ivu-switch ivu-switch-large"  idd="totalCount"  text="总计">
                        <span class="ivu-switch-inner">
                            <span slot="close">关闭</span>
                        </span>
                    </span>
                </div>
            </div>
    </div>
   
</div>`).appendTo($("#main_router_view"));
    }

    //显示panel
    show({x, y}) {
        $("#" + this.panelId)
            .show()
            .css("left", x + 15)
            .css("top", y + 15);
    }
}

export default GridSettingPanel;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/extend/gridSettingPanel.js